var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Test-Tracking",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1149.000000, -657.000000)",
    id: "Group-5-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(178.000000, 652.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button-/-Symbol-Small-/-Base",
    transform: "translate(966.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Date-picker",
    transform: "translate(5.714286, 5.714286)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#D8D8D8",
    opacity: 0,
    x: 0,
    y: 0,
    width: 20.5714286,
    height: 20.5714286
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,9.42857143 L8,10.952381 L6.47619048,10.952381 L6.47619048,9.42857143 L8,9.42857143 M11.047619,9.42857143 L11.047619,10.952381 L9.52380952,10.952381 L9.52380952,9.42857143 L11.047619,9.42857143 M14.0952381,9.42857143 L14.0952381,10.952381 L12.5714286,10.952381 L12.5714286,9.42857143 L14.0952381,9.42857143 M15.6190476,4.0952381 C16.4606244,4.0952381 17.1428571,4.77747086 17.1428571,5.61904762 L17.1428571,16.2857143 C17.1428571,17.127291 16.4606244,17.8095238 15.6190476,17.8095238 L4.95238095,17.8095238 C4.10666667,17.8095238 3.42857143,17.1238095 3.42857143,16.2857143 L3.42857143,5.61904762 C3.42857143,4.77747086 4.11080419,4.0952381 4.95238095,4.0952381 L5.71428571,4.0952381 L5.71428571,2.57142857 L7.23809524,2.57142857 L7.23809524,4.0952381 L13.3333333,4.0952381 L13.3333333,2.57142857 L14.8571429,2.57142857 L14.8571429,4.0952381 L15.6190476,4.0952381 M15.6190476,16.2857143 L15.6190476,7.9047619 L4.95238095,7.9047619 L4.95238095,16.2857143 L15.6190476,16.2857143 M8,12.4761905 L8,14 L6.47619048,14 L6.47619048,12.4761905 L8,12.4761905 M11.047619,12.4761905 L11.047619,14 L9.52380952,14 L9.52380952,12.4761905 L11.047619,12.4761905 M14.0952381,12.4761905 L14.0952381,14 L12.5714286,14 L12.5714286,12.4761905 L14.0952381,12.4761905 Z",
    id: "Shape",
    fill: "#616674"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.136561f541995cc80fc73d23e31487ab.svg";
export { ForwardRef as ReactComponent };